import BaseError from "./BaseError";

export default class NetworkError extends BaseError {
  constructor() {
    super('Network Error', 'Web client cannot reach the server.');
  }
}
